/**
 * BpmnAppendButton - Botão "+" exibido abaixo de um bloco sem saída
 *
 * Permite continuar o ramo sem precisar arrastar uma linha: abre a mesma lista
 * de blocos usada pela paleta e pelo "+" das linhas.
 *
 * @version 1.0.0
 * RELEASE: 2026-08-31 v1.0.0 - Criação inicial (inserção guiada de blocos)
 */

import { Plus } from 'lucide-react';
import { NodePickerPopover } from './NodePickerPopover';
import type { WorkflowPaletteItem } from '../workflowNodeMeta';

interface BpmnAppendButtonProps {
  onSelect: (item: WorkflowPaletteItem) => void;
}

export function BpmnAppendButton({ onSelect }: BpmnAppendButtonProps) {
  return (
    <NodePickerPopover
      onSelect={onSelect}
      trigger={
        <button
          type="button"
          title="Adicionar próximo bloco"
          onClick={(e) => e.stopPropagation()}
          className="nodrag flex h-6 w-6 items-center justify-center rounded-full border border-dashed border-primary/50 bg-card text-primary transition-colors hover:bg-primary hover:text-primary-foreground"
        >
          <Plus className="h-3.5 w-3.5" />
        </button>
      }
    />
  );
}
